/* @ngInject */

export default (
  $rootScope,
  dateTimeService,
  FeeAndCharge,
  AssetFinanceVerificationApplicant,
  Address,
  YesNoOption
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceCompliance(
    comments,
    monthlyFinancialPosition,
    verifications,
    basisForRecommendationsMade,
    interestDisclosure,
    productSuitability,
    feesAndCharges,
    basisForRecommendationsMadeAndCustomerDisclosures
  ) {
    this.comments = comments;
    this.monthlyFinancialPosition = monthlyFinancialPosition;
    this.verifications = verifications;
    this.basisForRecommendationsMade = basisForRecommendationsMade;
    this.interestDisclosure = interestDisclosure;
    this.productSuitability = productSuitability;
    this.feesAndCharges = feesAndCharges;
    this.basisForRecommendationsMadeAndCustomerDisclosures = basisForRecommendationsMadeAndCustomerDisclosures;

    if (
      this.verifications &&
      this.verifications.applicants &&
      this.verifications.applicants.length
    ) {
      this.verifications.applicants = _.map(
        _.compact(this.verifications.applicants),
        (verificationApplicant) =>
          AssetFinanceVerificationApplicant.Build(verificationApplicant)
      );
    }

    if (!this.verifications?.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently) {
      this.verifications.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently = '';
    }
    if (!this.verifications?.interviewDetailsInterviewWasConductedInTheFollowingLanguage) {
      this.verifications.interviewDetailsInterviewWasConductedInTheFollowingLanguage = '';
    }
    if (!this.verifications?.interviewDetailsInterviewIsBrokerFluentInThisLanguage) {
      this.verifications.interviewDetailsInterviewIsBrokerFluentInThisLanguage = '';
    }
    if (!this.verifications?.interviewDetailsInterviewWasTranslatorUsed) {
      this.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
    }

    if (!this.comments?.lenderSelectionJustification) {
      this.comments.lenderSelectionJustification = undefined;
    }
    if (!this.comments?.productSelectionJustification) {
      this.comments.productSelectionJustification = undefined;
    }
    if (!this.comments?.analysisAssessmentAndApplicantEducation) {
      this.comments.analysisAssessmentAndApplicantEducation = '';
    }
    if (!this.comments?.optionsPresentedAndRecommendation) {
      this.comments.optionsPresentedAndRecommendation = '';
    }

    switch (this.interestDisclosure?.isConflict) {
      case true:
        this.interestDisclosure.isConflict = YesNoOption.yes;
        break;
      case false:
        this.interestDisclosure.isConflict = YesNoOption.no;
        break;
      default:
        this.interestDisclosure.isConflict = YesNoOption.of(
          this.interestDisclosure?.isConflict?.name
        );
        break;
    }

    if (this.interestDisclosure?.lenderConflictOfInterest === undefined) {
      this.interestDisclosure.lenderConflictOfInterest = false;
    }
    if (this.interestDisclosure?.lenderConflictOfInterestComments === undefined) {
      this.interestDisclosure.lenderConflictOfInterestComments = '';
    }
    if (this.interestDisclosure?.referralConflictOfInterest === undefined) {
      this.interestDisclosure.referralConflictOfInterest = false;
    }
    if (this.interestDisclosure?.referralConflictOfInterestComments === undefined) {
      this.interestDisclosure.referralConflictOfInterestComments = '';
    }
    if (this.interestDisclosure?.otherConflictOfInterest === undefined) {
      this.interestDisclosure.otherConflictOfInterest = false;
    }
    if (this.interestDisclosure?.otherConflictOfInterestComments === undefined) {
      this.interestDisclosure.otherConflictOfInterestComments = '';
    }

    if (_.isEmpty(this.basisForRecommendationsMadeAndCustomerDisclosures)) {
      this.basisForRecommendationsMadeAndCustomerDisclosures.designDistributionObligations =
        YesNoOption.none;
      this.basisForRecommendationsMadeAndCustomerDisclosures.designDistributionObligationsComments =
        '';
    } else {
      this.basisForRecommendationsMadeAndCustomerDisclosures.designDistributionObligations = YesNoOption.of(
        this.basisForRecommendationsMadeAndCustomerDisclosures?.designDistributionObligations
          ?.name
      );
      this.basisForRecommendationsMadeAndCustomerDisclosures.designDistributionObligationsComments =
        this.basisForRecommendationsMadeAndCustomerDisclosures
          ?.designDistributionObligationsComments || '';
    }
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceCompliance.Blank = function () {
    return AssetFinanceCompliance.Build({
      comments: {
        analysisAssessmentAndApplicantEducation: '',
        optionsPresentedAndRecommendation: '',
        creditHistory: '',
        abilityToServiceFinancialAnalysis: '',
        livingExpenses: '',
        general: '',
        backgroundPurpose: '',
        lenderAndProductSelectionJustification: ''
      },
      monthlyFinancialPosition: {
        netIncome: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        lessTotalCurrentRepayment: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        lessTotalProposedRepayment: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        lessTotalCurrentExpenses: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        foreseeableFinancialChanges: {
          debtCommitmentsCeasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          incomeIncreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          expenseDecreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          newDebtCommitments: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          incomeDecreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          expenseIncreasing: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0,
            comments: ''
          },
          total: {
            currentPosition: 0,
            proposedPosition: 0,
            proposedPositionAtBufferRate: 0
          }
        },
        surplusDeficit: {
          currentPosition: 0,
          proposedPosition: 0,
          proposedPositionAtBufferRate: 0,
          comments: ''
        },
        totalAssets: 0,
        totalLiabilities: 0,
        netAssetPosition: 0,
        totalOutgoings: 0,
        netCashPosition: 0,
        financialRisk: 0,
        hemVariance: 0,
        debtToIncomeRatio: 0,
        totalWords: 0
      },
      verifications: {
        applicants: [],
        interviewDetailsMethod: '',
        interviewDetailsAttendees: '',
        interviewDetailsLocation: Address.blank(),
        interviewDetailsDateVerified: 0,
        interviewDetailsCustomersSpeakAndUnderstandEnglishFluently: '',
        interviewDetailsInterviewWasConductedInTheFollowingLanguage: '',
        interviewDetailsInterviewIsBrokerFluentInThisLanguage: '',
        interviewDetailsInterviewWasTranslatorUsed: '',
        antiMoneyLaunderingChecksCompleted: '',
        antiMoneyLaunderingChecksCompletedVerificationMethod: '',
        antiMoneyLaunderingChecksCompletedDateVerified: 0,
        creditChecksCompleted: '',
        creditChecksCompletedVerificationMethod: '',
        creditChecksCompletedDateVerified: 0,
        incomeVerificationCompletedVerificationMethod: '',
        incomeVerificationCompletedDateVerified: 0,
        livingExpensesVerified: '',
        livingExpensesVerifiedVerificationMethod: '',
        livingExpensesVerifiedDateVerified: 0,
        assetInspection: '',
        assetInspectionVerificationMethod: '',
        assetInspectionDateVerified: 0,
        completePpsrCheck: '',
        completePpsrCheckVerificationMethod: '',
        completePpsrCheckDateVerified: 0,
        completeConfirmationOfOwnership: '',
        completeConfirmationOfOwnershipVerificationMethod: '',
        completeConfirmationOfOwnershipDateVerified: 0
      },
      basisForRecommendationsMade: {
        refinanceExistingFacility: {
          mayEncounterCost: false,
          isRefinancingExistingCredit: false
        },
        financeAddOnsAndInsurances: false,
        financeTerm: {
          longer: false,
          earlier: false
        },
        paymentFrequency: false,
        balloonPayment: {
          continueWithBalloonPayment: false,
          isSubjectToCreditAssessment: false,
          payToSettleDebt: false,
          payToSettleDebtOption: 0
        }
      },
      interestDisclosure: {
        isConflict: YesNoOption.none,
        lenderConflictOfInterest: false,
        lenderConflictOfInterestComments: '',
        referralConflictOfInterest: false,
        referralConflictOfInterestComments: '',
        otherConflictOfInterest: false,
        otherConflictOfInterestComments: '',
        comments: ''
      },
      productSuitability: {
        isUnsuitable: null,
        isProductInconsistent: false,
        isApplicantComply: false
      },
      feesAndCharges: [],
      basisForRecommendationsMadeAndCustomerDisclosures: {
        designDistributionObligations: YesNoOption.none,
        designDistributionObligationsComments: ''
      }
    });
  };

  AssetFinanceCompliance.Build = function (data) {
    return new AssetFinanceCompliance(
      data.comments
        ? data.comments
        : {
            analysisAssessmentAndApplicantEducation: '',
            optionsPresentedAndRecommendation: '',
            creditHistory: '',
            abilityToServiceFinancialAnalysis: '',
            livingExpenses: '',
            general: '',
            backgroundPurpose: '',
            lenderAndProductSelectionJustification: ''
          },
      data.monthlyFinancialPosition
        ? data.monthlyFinancialPosition
        : {
            netIncome: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            lessTotalCurrentRepayment: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            lessTotalProposedRepayment: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            lessTotalCurrentExpenses: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            foreseeableFinancialChanges: {
              debtCommitmentsCeasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              incomeIncreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              expenseDecreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              newDebtCommitments: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              incomeDecreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              expenseIncreasing: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0,
                comments: ''
              },
              total: {
                currentPosition: 0,
                proposedPosition: 0,
                proposedPositionAtBufferRate: 0
              }
            },
            surplusDeficit: {
              currentPosition: 0,
              proposedPosition: 0,
              proposedPositionAtBufferRate: 0,
              comments: ''
            },
            totalAssets: 0,
            totalLiabilities: 0,
            netAssetPosition: 0,
            totalOutgoings: 0,
            netCashPosition: 0,
            financialRisk: 0,
            hemVariance: 0,
            debtToIncomeRatio: 0,
            totalWords: 0
          },
      data.verifications
        ? data.verifications
        : {
            applicants: [],
            interviewDetailsMethod: '',
            interviewDetailsAttendees: '',
            interviewDetailsLocation: Address.blank(),
            interviewDetailsDateVerified: 0,
            interviewDetailsCustomersSpeakAndUnderstandEnglishFluently: '',
            interviewDetailsInterviewWasConductedInTheFollowingLanguage: '',
            interviewDetailsInterviewIsBrokerFluentInThisLanguage: '',
            interviewDetailsInterviewWasTranslatorUsed: '',
            antiMoneyLaunderingChecksCompleted: '',
            antiMoneyLaunderingChecksCompletedVerificationMethod: '',
            antiMoneyLaunderingChecksCompletedDateVerified: 0,
            creditChecksCompleted: '',
            creditChecksCompletedVerificationMethod: '',
            creditChecksCompletedDateVerified: 0,
            incomeVerificationCompletedVerificationMethod: '',
            incomeVerificationCompletedDateVerified: 0,
            livingExpensesVerified: '',
            livingExpensesVerifiedVerificationMethod: '',
            livingExpensesVerifiedDateVerified: 0,
            assetInspection: '',
            assetInspectionVerificationMethod: '',
            assetInspectionDateVerified: 0,
            completePpsrCheck: '',
            completePpsrCheckVerificationMethod: '',
            completePpsrCheckDateVerified: 0,
            completeConfirmationOfOwnership: '',
            completeConfirmationOfOwnershipVerificationMethod: '',
            completeConfirmationOfOwnershipDateVerified: 0
          },
      data.basisForRecommendationsMade
        ? data.basisForRecommendationsMade
        : {
            refinanceExistingFacility: {
              mayEncounterCost: false,
              isRefinancingExistingCredit: false
            },
            financeAddOnsAndInsurances: false,
            financeTerm: {
              longer: false,
              earlier: false
            },
            paymentFrequency: false,
            balloonPayment: {
              continueWithBalloonPayment: false,
              isSubjectToCreditAssessment: false,
              payToSettleDebt: false,
              payToSettleDebtOption: 0
            }
          },
      data.interestDisclosure
        ? data.interestDisclosure
        : {
            isConflict: YesNoOption.none,
            lenderConflictOfInterest: false,
            lenderConflictOfInterestComments: '',
            referralConflictOfInterest: false,
            referralConflictOfInterestComments: '',
            otherConflictOfInterest: false,
            otherConflictOfInterestComments: '',
            comments: ''
          },
      data.productSuitability
        ? data.productSuitability
        : {
            isUnsuitable: null,
            isProductInconsistent: false,
            isApplicantComply: false
          },
      _.map(_.compact(data.feesAndCharges), (feeAndCharge) => FeeAndCharge.Build(feeAndCharge)),
      data.basisForRecommendationsMadeAndCustomerDisclosures
        ? data.basisForRecommendationsMadeAndCustomerDisclosures
        : {
            designDistributionObligations: YesNoOption.none,
            designDistributionObligationsComments: ''
          }
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceCompliance.prototype.getSetVerificationsInterviewDetailsDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.interviewDetailsDateVerified) {
          this.verifications.interviewDetailsDateVerifiedObject = '';
        }
        const interviewDetailsDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.interviewDetailsDateVerifiedObject = date;
        this.verifications.interviewDetailsDateVerified = moment
          .utc(interviewDetailsDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.interviewDetailsDateVerifiedObject = date;
        this.verifications.interviewDetailsDateVerified = 0;
      }
    }
    if (!this.verifications.interviewDetailsDateVerifiedObject) {
      if (this.verifications.interviewDetailsDateVerified) {
        const interviewDetailsDateVerifiedObject = dateTimeService.setDate(
          this.verifications.interviewDetailsDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.interviewDetailsDateVerifiedObject = interviewDetailsDateVerifiedObject;
      } else {
        this.verifications.interviewDetailsDateVerifiedObject = '';
      }
    }
    return this.verifications.interviewDetailsDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsAntiMoneyLaunderingChecksCompletedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.antiMoneyLaunderingChecksCompletedDateVerified) {
          this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = '';
        }
        const antiMoneyLaunderingChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = date;
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerified = moment
          .utc(antiMoneyLaunderingChecksCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = date;
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject) {
      if (this.verifications.antiMoneyLaunderingChecksCompletedDateVerified) {
        const antiMoneyLaunderingChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.antiMoneyLaunderingChecksCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = antiMoneyLaunderingChecksCompletedDateVerifiedObject;
      } else {
        this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsCreditChecksCompletedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.creditChecksCompletedDateVerified) {
          this.verifications.creditChecksCompletedDateVerifiedObject = '';
        }
        const creditChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.creditChecksCompletedDateVerifiedObject = date;
        this.verifications.creditChecksCompletedDateVerified = moment
          .utc(creditChecksCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.creditChecksCompletedDateVerifiedObject = date;
        this.verifications.creditChecksCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.creditChecksCompletedDateVerifiedObject) {
      if (this.verifications.creditChecksCompletedDateVerified) {
        const creditChecksCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.creditChecksCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.creditChecksCompletedDateVerifiedObject = creditChecksCompletedDateVerifiedObject;
      } else {
        this.verifications.creditChecksCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.creditChecksCompletedDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsIncomeVerificationCompletedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.incomeVerificationCompletedDateVerified) {
          this.verifications.incomeVerificationCompletedDateVerifiedObject = '';
        }
        const incomeVerificationCompletedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.incomeVerificationCompletedDateVerifiedObject = date;
        this.verifications.incomeVerificationCompletedDateVerified = moment
          .utc(incomeVerificationCompletedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.incomeVerificationCompletedDateVerifiedObject = date;
        this.verifications.incomeVerificationCompletedDateVerified = 0;
      }
    }
    if (!this.verifications.incomeVerificationCompletedDateVerifiedObject) {
      if (this.verifications.incomeVerificationCompletedDateVerified) {
        const incomeVerificationCompletedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.incomeVerificationCompletedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.incomeVerificationCompletedDateVerifiedObject = incomeVerificationCompletedDateVerifiedObject;
      } else {
        this.verifications.incomeVerificationCompletedDateVerifiedObject = '';
      }
    }
    return this.verifications.incomeVerificationCompletedDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsLivingExpensesVerifiedDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.livingExpensesVerifiedDateVerified) {
          this.verifications.livingExpensesVerifiedDateVerifiedObject = '';
        }
        const livingExpensesVerifiedDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.livingExpensesVerifiedDateVerifiedObject = date;
        this.verifications.livingExpensesVerifiedDateVerified = moment
          .utc(livingExpensesVerifiedDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.livingExpensesVerifiedDateVerifiedObject = date;
        this.verifications.livingExpensesVerifiedDateVerified = 0;
      }
    }
    if (!this.verifications.livingExpensesVerifiedDateVerifiedObject) {
      if (this.verifications.livingExpensesVerifiedDateVerified) {
        const livingExpensesVerifiedDateVerifiedObject = dateTimeService.setDate(
          this.verifications.livingExpensesVerifiedDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.livingExpensesVerifiedDateVerifiedObject = livingExpensesVerifiedDateVerifiedObject;
      } else {
        this.verifications.livingExpensesVerifiedDateVerifiedObject = '';
      }
    }
    return this.verifications.livingExpensesVerifiedDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsAssetInspectionDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.assetInspectionDateVerified) {
          this.verifications.assetInspectionDateVerifiedObject = '';
        }
        const assetInspectionDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.assetInspectionDateVerifiedObject = date;
        this.verifications.assetInspectionDateVerified = moment
          .utc(assetInspectionDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.assetInspectionDateVerifiedObject = date;
        this.verifications.assetInspectionDateVerified = 0;
      }
    }
    if (!this.verifications.assetInspectionDateVerifiedObject) {
      if (this.verifications.assetInspectionDateVerified) {
        const assetInspectionDateVerifiedObject = dateTimeService.setDate(
          this.verifications.assetInspectionDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.assetInspectionDateVerifiedObject = assetInspectionDateVerifiedObject;
      } else {
        this.verifications.assetInspectionDateVerifiedObject = '';
      }
    }
    return this.verifications.assetInspectionDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsCompletePpsrCheckDate = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.completePpsrCheckDateVerified) {
          this.verifications.completePpsrCheckDateVerifiedObject = '';
        }
        const completePpsrCheckDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.completePpsrCheckDateVerifiedObject = date;
        this.verifications.completePpsrCheckDateVerified = moment
          .utc(completePpsrCheckDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.completePpsrCheckDateVerifiedObject = date;
        this.verifications.completePpsrCheckDateVerified = 0;
      }
    }
    if (!this.verifications.completePpsrCheckDateVerifiedObject) {
      if (this.verifications.completePpsrCheckDateVerified) {
        const completePpsrCheckDateVerifiedObject = dateTimeService.setDate(
          this.verifications.completePpsrCheckDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.completePpsrCheckDateVerifiedObject = completePpsrCheckDateVerifiedObject;
      } else {
        this.verifications.completePpsrCheckDateVerifiedObject = '';
      }
    }
    return this.verifications.completePpsrCheckDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.getSetVerificationsCompleteConfirmationOfOwnershipDate = function (
    date
  ) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.verifications.completeConfirmationOfOwnershipDateVerified) {
          this.verifications.completeConfirmationOfOwnershipDateVerifiedObject = '';
        }
        const completeConfirmationOfOwnershipDateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.verifications.completeConfirmationOfOwnershipDateVerifiedObject = date;
        this.verifications.completeConfirmationOfOwnershipDateVerified = moment
          .utc(completeConfirmationOfOwnershipDateVerifiedObject)
          .startOf('day')
          .format('X');
      } else {
        this.verifications.completeConfirmationOfOwnershipDateVerifiedObject = date;
        this.verifications.completeConfirmationOfOwnershipDateVerified = 0;
      }
    }
    if (!this.verifications.completeConfirmationOfOwnershipDateVerifiedObject) {
      if (this.verifications.completeConfirmationOfOwnershipDateVerified) {
        const completeConfirmationOfOwnershipDateVerifiedObject = dateTimeService.setDate(
          this.verifications.completeConfirmationOfOwnershipDateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.verifications.completeConfirmationOfOwnershipDateVerifiedObject = completeConfirmationOfOwnershipDateVerifiedObject;
      } else {
        this.verifications.completeConfirmationOfOwnershipDateVerifiedObject = '';
      }
    }
    return this.verifications.completeConfirmationOfOwnershipDateVerifiedObject;
  };
  AssetFinanceCompliance.prototype.deleteDateObject = function () {
    delete this.verifications.interviewDetailsDateVerifiedObject;
    delete this.verifications.antiMoneyLaunderingChecksCompletedDateVerifiedObject;
    delete this.verifications.creditChecksCompletedDateVerifiedObject;
    delete this.verifications.incomeVerificationCompletedDateVerifiedObject;
    delete this.verifications.livingExpensesVerifiedDateVerifiedObject;
    delete this.verifications.assetInspectionDateVerifiedObject;
    delete this.verifications.completePpsrCheckDateVerifiedObject;
    delete this.verifications.completeConfirmationOfOwnershipDateVerifiedObject;
    if (
      this.verifications &&
      this.verifications.applicants &&
      this.verifications.applicants.length
    ) {
      for (let i = 0; i < this.verifications.applicants.length; i += 1) {
        delete this.verifications.applicants[i].dateVerifiedObject;
      }
    }
  };

  return AssetFinanceCompliance;
};
